"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_provider_1 = require("./apollo.provider");
exports.default = apollo_provider_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular1-apollo/build/src/index.js
// module id = 374
// module chunks = 0